import {
    SET_SHIPMENTS,
    SET_SHIPMENTS_DATA_LOADING,
    SET_SEARCH_SHIPMENTS,
    SET_SHIPMENT_FILTERS_VISIBILITY,
    SET_SEARCH_STATUS_DATA_LOADING,
    GET_SEARCH_TRACKING_NO,
    SET_SEARCH_TRACKING_NO_DATA_LOADING
} from "./types";
import store from "../../../../store";
import Axios from "../../../../common/util/Axios";

export const getShipments = (params) => async (dispatch) => {
    try {
        dispatch({ type: SET_SHIPMENTS_DATA_LOADING });

        const companyId = store.getState().authState.companyId;
        const branchId = store.getState().authState.branchId;
        const queryParams = {
            ...params,
            companyId
        };

        const res = await Axios.get(`/api/dashboard/delivery/find-all-delivery-orders`, {
            params: queryParams,
        });

        dispatch({
            type: SET_SHIPMENTS,
            payload: res.data.data,
        });
    } catch (err) {
        dispatch({
            type: SET_SHIPMENTS,
            payload: [],
        });
    }
};

export const setShipmentFilterVisibility = (visibility) => async (dispatch) => {
    dispatch({
        type: SET_SHIPMENT_FILTERS_VISIBILITY,
        payload: visibility,
    });
};

export const retryShipment = (id) => async () => {
    try {
        const res = await Axios.post(`/api/dashboard/delivery/retry`, { id });
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err.response?.data?.error || 'Failed to retry shipment',
        };
    }
};

export const searchTrackingNo = (keyword) => async (dispatch) => {
    try {
        dispatch({ type: SET_SEARCH_TRACKING_NO_DATA_LOADING });
        const companyId = store.getState().authState.companyId;
        const res = await Axios.get(`/api/dashboard/delivery/search-by-tracking-no`,
            {
                params: { companyId, keyword },
            }
        );
        dispatch({
            type: GET_SEARCH_TRACKING_NO,
            payload: res.data.data,
        });
    } catch (err) {
        dispatch({
            type: GET_SEARCH_TRACKING_NO,
            payload: [],
        });
    }
}